import Navigation from "@/components/Navigation";
import ContactForm from "@/components/Contact";
import Map from "@/components/Map";
import SocialLinks from "@/components/SocialLinks";

const Contact = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-24">
        <ContactForm />
        <section className="py-20 bg-muted">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div className="space-y-8">
                <h2 className="text-3xl font-serif">Connect With Us</h2>
                <SocialLinks />
              </div>
              <Map />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;